import React from "react";
import { useHistory } from "react-router-dom";
import { MissionSectionCards } from "../..";
import { missionVisionData } from "../../../assets/data/missionVisionData";

export default function MVTSingleSection(props) {
	const history = useHistory();

	const filteredData = missionVisionData.filter((data) => {
		return history.location.pathname === data.link;
	});

	return (
		<section className="no-pt no-px-md">
			<MissionSectionCards data={filteredData} noButton />
		</section>
	);
}
